/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import spacing from '../spacing';

type SpacingDefinitionValue = false | keyof typeof spacing;
interface SpacingDefinitionObject {
  left?: SpacingDefinitionValue;
  right?: SpacingDefinitionValue;
  top?: SpacingDefinitionValue;
  bottom?: SpacingDefinitionValue;
}
export type SpacingDefinition =
  | SpacingDefinitionValue
  | SpacingDefinitionObject;
type SpacingDirection = 'left' | 'right' | 'top' | 'bottom';
type SpacingType = 'margin' | 'padding';

export default class SpacingProps {
  private type: SpacingType;
  private directions: SpacingDirection[];

  constructor(
    type: SpacingType,
    directions: SpacingDirection[] = ['left', 'right', 'top', 'bottom']
  ) {
    this.type = type;
    this.directions = directions;
  }

  public stylesForProp = (propName: string) => (props: {
    [key: string]: any;
  }): string => {
    if (props[propName] === undefined) {
      return '';
    }
    return this.directions
      .map((direction) =>
        this.spacingForDirection(props[propName], direction, this.type)
      )
      .join(' ');
  };

  private spacingForDirection = (
    spacingDefinition: SpacingDefinition,
    direction: SpacingDirection,
    type: SpacingType
  ) => {
    let spacingValue: SpacingDefinition;
    if (typeof spacingDefinition === 'object') {
      spacingValue = spacingDefinition[direction] || false;
    } else {
      spacingValue = spacingDefinition;
    }

    if (spacingValue === false) {
      return `
        ${type}-${direction}: 0;
      `;
    }

    return `
      ${type}-${direction}: ${spacing[spacingValue]};
    `;
  };
}
